import { render, staticRenderFns } from "./groups-modal.vue?vue&type=template&id=243c2dfd&scoped=true&"
import script from "./groups-modal.vue?vue&type=script&lang=js&"
export * from "./groups-modal.vue?vue&type=script&lang=js&"
import style0 from "./groups-modal.vue?vue&type=style&index=0&id=243c2dfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243c2dfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('243c2dfd')) {
      api.createRecord('243c2dfd', component.options)
    } else {
      api.reload('243c2dfd', component.options)
    }
    module.hot.accept("./groups-modal.vue?vue&type=template&id=243c2dfd&scoped=true&", function () {
      api.rerender('243c2dfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions/groups-modal.vue"
export default component.exports